import { useMutation } from "@tanstack/react-query";
import { positionDelete } from "common/api/sakusas/sakusas_position";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasPositionDeleteParams = {
  invalidateKeys?: string[];
};

export const useSakusasPositionDelete = (
  hookParams?: UseSakusasPositionDeleteParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: positionDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await positionDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { positionDeleteMutate };
};
